import { useState } from "react";
import { LifeBuoy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { SupportRequestDialog } from "@/components/launch_pad/SupportRequestDialog";
import { SUPPORT_PORTAL_URL } from "@/api/supportRequests";

type LaunchPadSupportSectionProps = {
  municipalityId?: number;
  municipalityName?: string;
};

export function LaunchPadSupportSection({ municipalityId, municipalityName }: LaunchPadSupportSectionProps) {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <Card className="border-primary/20 bg-primary/5" data-testid="launch-pad-support">
        <CardHeader className="flex flex-row items-start gap-4 space-y-0 pb-2">
          <div className="rounded-full bg-primary/10 p-2.5">
            <LifeBuoy className="h-6 w-6 text-primary" aria-hidden />
          </div>
          <div className="flex-1 space-y-1">
            <CardTitle className="text-base">Need help from our team?</CardTitle>
            <CardDescription>
              To add a product to your account, contact your Customer Success Manager. For other
              questions, send us a message and we will follow up by email. For guides and FAQs, visit
              the{" "}
              <a
                href={SUPPORT_PORTAL_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="font-medium text-foreground underline-offset-4 hover:underline"
              >
                help center
              </a>
              .
            </CardDescription>
          </div>
        </CardHeader>
        <CardContent>
          <Button type="button" onClick={() => setDialogOpen(true)}>
            Contact support
          </Button>
        </CardContent>
      </Card>

      <SupportRequestDialog
        open={dialogOpen}
        onOpenChange={setDialogOpen}
        municipalityId={municipalityId}
        municipalityName={municipalityName}
      />
    </>
  );
}
